module.exports = __webpack_public_path__ + "static/media/fourteen.1c3bb034.jpg";